<template>
    <v-row>
        <v-col class="text-center py-0 pb-1" cols="12">
            <h1>Associar lotes à {{ info.tipo == 1 ? 'nota fiscal' : 'título'}}</h1>
        </v-col>
        <v-col class="text-right px-1 ml-0" cols="4">
            <p class="mb-0" style="font-size: 13px"><b>{{ info.tipo == 1 ? 'N° NF: ': 'N° Título: '}}</b>{{ info.tipo == 1 ? info.numero : info.nr_titulo}}</p>
        </v-col>
        <v-col class="text-center ml-2" cols="4">
            <p class="mb-0" style="font-size: 13px"><b>{{ info.tipo == 1 ? 'Data de emissão: ': 'Data de vencimento: '}}</b>{{info.tipo == 1 ? info.dt_emissao : info.data_venc_titulo | formatDate}}</p>
        </v-col>
        <v-col class="text-left px-1 ml-1" cols="3">
            <p class="mb-0" style="font-size: 13px"><b>{{ info.tipo == 1 ? 'Valor NF: ': 'Valor Título: '}}</b>R$ {{info.valor | formatPrice}}</p>
        </v-col>
        <v-col class="py-0" cols="12"><v-divider></v-divider></v-col>
        <v-col class="text-left" cols="6">
            <h1>Lotes</h1>
        </v-col>
        <v-col class="text-right" cols="6">
            <p style="font-size: 16px"><b>Total (R$): </b>{{ value.vl_total_lotes | formatPrice }}</p>
        </v-col>
        <v-col class="text-right" style="margin-top: -1.5rem" cols="12" sm="5" md="5">
            <v-text-field
                v-model="search"
                small
                height="30px"
                prepend-inner-icon="mdi-magnify"
                placeholder="Buscar"
                single-line
                outlined
                dense
                hide-details
            ></v-text-field>
        </v-col>
        <v-col class="text-left py-0" style="margin-top: -0.3rem" cols="auto">
            <v-checkbox
                class="pa-0 ma-0 pl-5"
                v-model="filter"
                :label="info.tipo == 1 ? 'Exibir lotes que já possuem notas fiscais' : 'Exibir lotes que já possuem títulos'"
                hide-details
                dense
                @change="filterList(lotes)"
                :disabled="cboxEnabled"
            ></v-checkbox>
        </v-col>
        <v-col cols="12">
            <v-data-table
                :headers="headers"
                :items="lotes"
                :sort-by="sortBy"
                :sort-desc="sortDesc"
                hide-default-footer
                class="lotesListTable"
                :items-per-page="-1"
                :search="search"
                :custom-filter="filtrando"
                single-select
            >   <template v-slot:item="props">
                    <tr>
                        <td class="text-left pa-2">
                            <v-tooltip bottom open-delay="500">
                                <template v-slot:activator="{ on, attrs }">
                                    <span v-bind="attrs" v-on="on">
                                        <span v-if="props.item.complementar && props.item.is_deleted" class="new-lote">novo</span>
                                        <span>{{ props.item.arq_nome }}</span>
                                    </span>
                                </template>
                                <span
                                    class="px-3 py-1 ma-0"
                                    style="border: solid 1px #999; border-radius: 5px; background-color: #FFF"
                                >{{ props.item.arq_nome }}</span>
                            </v-tooltip>
                        </td>
                        <td class="text-center pa-2">{{ cronograma.dt_faturamento  | formatDate }} </td>
                        <td class="text-center pa-2">{{ props.item.arq_numero_lote | formatNullValue }}</td>
                        <td class="text-right pa-2">{{ props.item.arq_vl_calculado | formatPrice}}</td>
                        <td class="text-center pa-2">{{ props.item.arq_nfs ? props.item.arq_nfs.join(", ") : null | formatNullValue }}</td>
                        <td class="text-center pa-2">
                            <v-btn small color="primary lighten-2" icon>
                                <v-switch
                                    inset
                                    multiple
                                    v-model="lotesAssociadosList"
                                    :key="props.item.id"
                                    :value="props.item"
                                    :input-value="props.item.is_associada"
                                    @change="assocLotes(lotesAssociadosList); atualizaBotao()"
                                ></v-switch>
                            </v-btn>
                        </td>
                    </tr>
                </template>

                <template v-slot:header.is_associada class="text-center pa-2">
                    <v-row v-if="search.length == 0">
                        <v-col cols="5" class="text-left">
                            Associado

                        </v-col>
                        <v-col cols="7" class="text-left">
                            <v-btn small color="primary lighten-2" icon>
                                <v-switch
                                inset
                                v-model="seleTodos"
                                @change="confirmSelecionaTodos">
                                </v-switch>
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-row v-else>
                        <v-col cols="12" class="text-center">
                            Associado

                        </v-col>
                    </v-row>
                </template> 
            </v-data-table>
        </v-col>
    </v-row>
</template>

<script>
import moment from 'moment';
moment.locale("pt-BR");
export default {
    props: {
        info: Object,
        list: Array,
        assocLotes: Function,
        cronograma: Object
    },
    data() {
        return {
            headers: [
                { text: "Arquivo", value: "arq_nome", sortable: false, 'filterable': true },
                { text: "Cronograma", value: "dt_vencimento", align: "center",sortable: false, 'filterable': false },
                { text: "Núm. lote", align: "center", value: "arq_numero_lote", sortable: false, 'filterable': true },
                { text: "Valor (R$)", value: "arq_vl_calculado", sortable: false, 'filterable': true, align: "center" },
                { text: "Número", value: "arq_nfs", sortable: false, 'filterable': true, align: "center" },
                { text: "Associado", value: "is_associada", sortable: false },
            ],
            lotesAssociadosList: null,
            lotes: [],
            sortBy: "is_associada",
            sortDesc: true,
            search: '',
            filter: false,
            value: {},
            seleTodos: null, 
        }
    },
    computed: {
      cboxEnabled() {
        let hasNfAssociada = this.list.every((item) => item.nfs_associadas && item.nfs_associadas.length === 0)
        return hasNfAssociada
      },
    },
    filters: {
        formatPrice(value) {
            let val = (value/1).toFixed(2).replace('.', ',')
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
        },
        formatDate(date) {
            return moment(date).format("L")
        },
        formatNullValue(val) {
            return val ? val : '-'
        },
    },
    watch: {
        list(val) {
            this.seleTodos = false
            this.filter = false;
            this.search = "";
            this.lotes = val.filter((item) => (!item.nfs_associadas  || !item.nfs_associadas.length) || (item.nfs_associadas && item.nfs_associadas.includes(this.info.id)));
            this.lotesAssociadosList = val.filter(item => item.is_associada == 1 && item.nfs_associadas && item.nfs_associadas.includes(this.info.id));
            let lotesAssociados = val.map(item => {
                if(item.is_associada && item.nfs_associadas.includes(this.info.id))
                return item.arq_vl_calculado

                return 0;
            });
            let vlTotal = lotesAssociados.reduce((total, item) => total + item, 0)
            this.value = { vl_total_lotes: vlTotal }
        },
        lotesAssociadosList() {
            this.atualizaBotao()
            let vlTotal = this.lotesAssociadosList.reduce((total, item) => total + item.arq_vl_calculado, 0)
            this.value = { vl_total_lotes: vlTotal }
        },

        
    },
    methods: {
      filterList() {
        if (this.filter) {
          this.lotes = this.list
          this.sortBy = 'arq_nfs'
        }
        else {
          this.lotes = this.list.filter((item) => !item.nfs_associadas.length || item.nfs_associadas.includes(this.info.id))
          this.sortBy = 'is_associada'
        }
      },
        selecionaTodos(){
            if(this.seleTodos == true){
                this.lotesAssociadosList = this.lotes
                this.assocLotes(this.lotesAssociadosList)
            } else {
                this.lotesAssociadosList = []
                this.assocLotes(this.lotesAssociadosList)
            }
        },
      
        atualizaBotao(){
            if(this.lotesAssociadosList.length < this.lotes.length)
                this.seleTodos = false
            else if(this.lotesAssociadosList.length == this.lotes.length)
                this.seleTodos = true
        },

        filtrando(value, search){
            if(value != null && search != null && typeof value === 'string' &&  value.toString().toLocaleLowerCase().indexOf(search.toLocaleLowerCase()) !== -1){
                return true
            }
        },

        confirmSelecionaTodos(val) {
            let acao = val? "associar": "desassociar";
            let paramModal = {
                type: "warning",
                title: "Aviso",
                message: `Deseja ${acao} todos os ${this.list.length} lotes.`,
                callback: () => this.selecionaTodos(),
                btConfirm: { name: "Ok", show: true},
                btCancel: { name: "Cancelar", show: true, callback: () => { this.seleTodos = !this.seleTodos }},
            }
            this.$store.commit('confirmMessage/showConfirmMessage', paramModal);
        }
        
      
    }

}
</script>

<style scoped>
.v-data-table {
  max-height: 34vh;
  overflow-y: scroll;
  overflow-x: hidden;
  overscroll-behavior: contain;
}
.new-lote {
  background-color: #cfd403;
  border-radius: 6px;
  padding: 0px 4px;
  font-size: 8px;
  font-family: sans-serif;
  font-weight: 700;
  margin-right: 3px;
  position: relative;
  bottom: 4px;
}
</style>